export const applicationPermissions = {
  authentication: {},
  authorization: {
    //just added
    menuPermission: 'menu-authorization',
    readPermission: 'read-authorization',
    role: {
      //just added
      menuPermission: 'menu-role',
      readPermission: 'read-role',
      updatePermission: 'update-role',
      deletePermission: 'delete-role',
      createPermission: 'create-role',
      rolePermission: {
        //just added
        menuPermission: 'menu-role-permission',
        readPermission: 'read-role-permission',
        updatePermission: 'update-role-permission',
        deletePermission: 'delete-role-permission',
        createPermission: 'create-role-permission',
      },
      saveAssignedPermissionButton: 'save-assigned-permission-button',
    },
    projectModule: {
      //just added
      menuPermission: 'menu-project-module',
      readPermission: 'read-project-module',
      updatePermission: 'update-project-module',
      deletePermission: 'delete-project-module',
      createPermission: 'create-project-module',
    },
    permission: {
      //just added
      menuPermission: 'menu-permission',
      readPermission: 'read-permission',
      updatePermission: 'update-permission',
      deletePermission: 'delete-permission',
      createPermission: 'create-permission',
    },
    featurePermission: {
      menuFeaturePermission: 'menu-feature-permission',
    },
    log: {
      authenticationLogPermission: 'authentication-log-permission',
      aclActivityLogPermission: 'acl-activity-log-permission',
    }
  },
  user: {
    menuPermission: 'menu-user',
    readPermission: 'read-user',
    userList: {
      menuPermission: 'menu-user-list',
      menuCreateUserPermission: 'menu-create-user',
      readPermission: 'read-user',
      updatePermission: 'update-user',
      deletePermission: 'delete-user',
      createPermission: 'create-user',
      stpReadPermission: 'get-stp-user-by-id',
      createNewStpUser: 'create-new-stp-user',
      readStpUser: 'read-stp-user',
      changeUserStatus: 'change-user-status'
    },
    userDetails: {
      menuPermission: 'menu-user-details',
      readPermission: 'read-user-details',
      updatePermission: 'update-user-details',
      deletePermission: 'delete-user-details',
      createPermission: 'create-user-details',
      getAllStpUserIdAclUserIdAndName: 'get-all-stpUserId-aclUserId-and-Name',
    },
    userProfile: {
      menuPermission: 'menu-user-profile',
      readPermission: 'read-user-profile',
      updatePermission: 'update-user-profile',
      deletePermission: 'delete-user-profile',
      createPermission: 'create-user-profile',
    },
    log: {
      aclUserActivityLogPermission: 'acl-user-activity-log-permission',
    },
  },

  tci: {
    menuPermission: 'menu-tci',
    readPermission: 'read-tci',
    menuSendEmail: 'menu-send-all-email',
    tciList: {
      menuPermission: 'menu-tci-list',
      readPermission: 'read-tci-list',
      updatePermission: 'update-tci-list',
      deletePermission: 'delete-tci-list',
      createPermission: 'create-tci-list',
      menuUploadCertificateListPermission: 'menu-upload-tci-list',
    },
    tciView: {
      menuPermission: 'menu-tci-view',
      readPermission: 'read-tci-view',
      updatePermission: 'update-tci-view',
      deletePermission: 'delete-tci-view',
      createPermission: 'create-tci-view',
    },
  },
  appeal: {
    menuPermission: 'menu-appeal',
    appeal: {
      menuListPermission: 'menu-appeal-list',
      menuListAdminPermission: 'menu-appeal-list-admin',
      menuCreatePermission: 'menu-appeal-create',
      readPermission: 'read-appeal',
      createPermission: 'create-appeal',
      updatePermission: 'update-appeal',
      deletePermission: 'delete-appeal',
      committeeReviewButtonPermission: 'appeal-committee-review-button',
      onlinePaymentButtonPermission: 'online-payment-button-permission',
      appealViewAdminPermission: 'appeal-view-admin',
      menuPaymentSetupPermission: 'menu-appeal-payment-setup',
    },
    log: {
      appealActivityLogPermission: 'appeal-activity-log-permission',
    },
  },
  tam: {
    menuPermission: 'menu-tam',
    readPermission: 'read-tam-main',
    tam: {
      menuCreatePermission: 'menu-tam-create',
      menuListPermission: 'menu-tam-list',
      updatePermission: 'update-tam-main',
      deletePermission: 'delete-tam-main',
      createPermission: 'create-tam-main',
    },
    tamView: {
      menuPermission: 'menu-tam-view',
      readPermission: 'read-tam-view',
    },
    archive: {
      menuListPermission: 'menu-archive-list',
      readPermission: 'read-tam-archive-list',
    },
    occupation: {
      menuPermission: 'menu-occupation',
      menuListPermission: 'menu-occupation-list',
      readPermission: 'read-tam-occupation',
      updatePermission: 'update-tam-occupation',
      deletePermission: 'delete-tam-occupation',
      createPermission: 'create-tam-occupation',
      menuCreatePermission: 'menu-occupation-create',
    },
    tamOccupation: {
      readPermission: 'read-tam-occupation-list',
      // updatePermission: 'update-information-for-cad',
      // deletePermission: 'delete-information-for-cad',
      // createPermission: 'create-information-for-cad',
    },
    informationForCs: {
      menuPermission: 'menu-information-for-cs',
      readPermission: 'read-information-for-cs',
      updatePermission: 'update-information-for-cs',
      deletePermission: 'delete-information-for-cs',
      createPermission: 'create-information-for-cs',
    },
    informationForCad: {
      menuPermission: 'menu-information-for-cad',
      readPermission: 'read-information-for-cad',
      updatePermission: 'update-information-for-cad',
      deletePermission: 'delete-information-for-cad',
      createPermission: 'create-information-for-cad',
    },
    informationForCBLM: {
      menuPermission: 'menu-information-for-cblm',
      readPermission: 'read-information-for-cblm',
      updatePermission: 'update-information-for-cblm',
      deletePermission: 'delete-information-for-cblm',
      createPermission: 'create-information-for-cblm',
    },
    CBLM: {
      menuGenericCompetency: 'menu-generic-competency',
      menuSectorCompetency: 'menu-sector-competency',
      menuOccupationCompetency: 'menu-occupation-competency',
      menuArchiveGenericCompetency: 'menu-archive-generic-competency',
      menuArchiveSectorCompetency: 'menu-archive-sector-competency',
      menuArchiveOccupationCompetency: 'menu-archive-occupation-competency',
    },
    log: {
      tamActivityLogPermission: 'tam-activity-log-permission',
    },
  },
  payment: {
    menuPermission: 'menu-payment',
    readPermission: 'read-payment',
    paymentList: {
      menuPermission: 'menu-payment-list',
      menuGatewayPermission: 'menu-gateway-payment',
      readPermission: 'read-payment-list',
    },
    paymentHistory: {
      menuPaymentHistory: 'menu-payment-history',
      menuStpPaymentHistory: 'menu-stp-payment-history',
      menuCourseAccreditationPaymentHistory: 'menu-course-accreditation-payment-history',
      menuAssessmentPaymentHistory: 'menu-assessment-payment-history',
      regularAssessmentManagePaymentButtonPermission: 'regular-assessment-manage-payment-button-permission',
      rplAssessmentManagePaymentButtonPermission: 'rpl-assessment-manage-payment-button-permission',
      stpManagePaymentButtonPermission: 'stp-manage-payment-button-permission',
      courseManagePaymentButtonPermission: 'course-manage-payment-button-permission',
    },
    paymentType: {
      menuPermission: 'menu-payment-type',
      readPermission: 'read-payment-type-list',
      writePermission: 'write-payment-type',
    },
  },
  applicant: {
    menuPermission: 'menu-applicant',
    readPermission: 'read-applicant',
    applicantList: {
      menuPermission: 'menu-applied-list',
      readPermission: 'read-applied-list',
      updatePermission: 'update-applied-list',
      deletePermission: 'delete-applied-list',
      createPermission: 'create-applied-list',
    },
    applicantForm: {
      menuPermission: 'menu-application-form',
      readPermission: 'read-application-form',
      updatePermission: 'update-application-form',
      deletePermission: 'delete-application-form',
      createPermission: 'create-application-form',
    },
    applicantShortList: {
      menuPermission: 'menu-applicant-short-list',
      readPermission: 'read-applicant-short-list',
      updatePermission: 'update-applicant-short-list',
      deletePermission: 'delete-applicant-short-list',
      createPermission: 'create-applicant-short-list',
    },
    applicantPreviewForm: {
      menuPermission: 'menu-rpl-indiv-create-circular',
      readPermission: 'read-application-preview-form',
      updatePermission: 'update-application-preview-form',
      deletePermission: 'delete-application-preview-form',
      createPermission: 'create-application-preview-form',
      approvedButtonPermission: 'approved-button-permission',
      rejectButtonPermission: 'reject-button-permission'
    },
    paymentSetup: {
      menuPermission: 'menu-rpl-ind-payment-setup-permission',
      readPermission: 'read-rpl-ind-payment-setup-permission',
      updatePermission: 'update-rpl-ind-payment-setup-permission',
      deletePermission: 'delete-rpl-ind-payment-setup-permission',
      createPermission: 'create-rpl-ind-payment-setup-permission',
    },
    createCircularForm: {
      menuPermission: 'menu-rpl-indiv-create-circular-form',
      readPermission: 'read-create-circular-form',
      updatePermission: 'update-create-circular-form',
      deletePermission: 'delete-create-circular-form',
      createPermission: 'create-create-circular-form',
    },
    circulaList: {
      menuPermission: 'menu-circular-list',
      readPermission: 'read-circular-list',
      updatePermission: 'update-circular-list',
      deletePermission: 'delete-circular-list',
      createPermission: 'create-circular-list',
    },
    appliedCircularList: {
      menuPermission: 'menu-applied-circular-list',
      readPermission: 'read-applied-circular-list',
      updatePermission: 'update-applied-circular-list',
      deletePermission: 'delete-applied-circular-list',
      createPermission: 'create-applied-circular-list',
    },
    archiveCircularList: {
      menuPermission: 'menu-archive-circular-list',
      readPermission: 'read-archive-circular-list',
      updatePermission: 'update-archive-circular-list',
      deletePermission: 'delete-archive-circular-list',
      createPermission: 'create-archive-circular-list',
    },
    circulaListAdmin: {
      menuPermission: 'menu-circular-list-admin',
      readPermission: 'read-circular-list-admin',
      updatePermission: 'update-circular-list-admin',
      deletePermission: 'delete-circular-list-admin',
      createPermission: 'create-circular-list-admin',
    },
    rplIndividualBatchScheduleLayer1: {
      menuPermission: 'menu-batch-schedule-layer-one',
      readPermission: 'read-batch-schedule-layer-one',
      updatePermission: 'update-batch-schedule-layer-one',
      deletePermission: 'delete-batch-schedule-layer-one',
      createPermission: 'create-batch-schedule-layer-one',
      scheduleLevel1ButtonPermission: "schedule-level-1-button-permission",
    },
    rplIndividualBatchScheduleLayer2: {
      menuPermission: 'menu-batch-schedule-layer-two',
      readPermission: 'read-batch-schedule-layer-two',
      updatePermission: 'update-batch-schedule-layer-two',
      deletePermission: 'delete-batch-schedule-layer-two',
      createPermission: 'create-batch-schedule-layer-two',
      scheduleLevel2ButtonPermission: "schedule-level-2-button-permission",
    },
    rplIndividualBatchScheduleLayer3: {
      menuPermission: 'menu-batch-schedule-layer-three',
      readPermission: 'read-batch-schedule-layer-three',
      updatePermission: 'update-batch-schedule-layer-three',
      deletePermission: 'delete-batch-schedule-layer-three',
      createPermission: 'create-batch-schedule-layer-three',
      scheduleLevel3ButtonPermission: "schedule-level-3-button-permission",
    },
    rplIndividualBatchScheduleLayer4: {
      menuPermission: 'menu-batch-schedule-layer-four',
      readPermission: 'read-batch-schedule-layer-four',
      updatePermission: 'update-batch-schedule-layer-four',
      deletePermission: 'delete-batch-schedule-layer-four',
      createPermission: 'create-batch-schedule-layer-four',
      scheduleLevel4ButtonPermission: "schedule-level-4-button-permission",
    },
    rplIndividualBatchList: {
      menuPermission: 'menu-rpl-individual-batch-list',
      readPermission: 'read-rpl-individual-batch-list',
      updatePermission: 'update-rpl-individual-batch-list',
      deletePermission: 'delete-rpl-individual-batch-list',
      createPermission: 'create-rpl-individual-batch-list',
    },
    rplIndividualAssignedAssessmentList: {
      menuPermission: 'menu-rpl-individual-assigned-assessment-list',
      readPermission: 'read-rpl-individual-assigned-assessment-list',
      updatePermission: 'update-rpl-individual-assigned-assessment-list',
      deletePermission: 'delete-rpl-individual-assigned-assessment-list',
      createPermission: 'create-rpl-individual-assigned-assessment-list',
    },
    rplIndividualResultUpload: {
      menuPermission: 'menu-rpl-individual-result-upload',
      readPermission: 'read-rpl-individual-result-upload',
      updatePermission: 'update-rpl-individual-result-upload',
      deletePermission: 'delete-rpl-individual-result-upload',
      createPermission: 'create-rpl-individual-result-upload',
      rplIndUploadResultButtonPermission: "rpl-ind-upload-result-button-permission",
    },
    rplIndividualResultScrutiny: {
      menuPermission: 'menu-rpl-individual-result-scrutiny',
      readPermission: 'read-rpl-individual-result-scrutiny',
      updatePermission: 'update-rpl-individual-result-scrutiny',
      deletePermission: 'delete-rpl-individual-result-scrutiny',
      createPermission: 'create-rpl-individual-result-scrutiny',
      rplIndResultScrutinyButtonPermission: "rpl-ind-result-scrutiny-button-permission",
    },
    rplIndividualResultIssueCertificates: {
      menuPermission: 'menu-rpl-individual-result-issue-certificates',
      readPermission: 'read-rpl-individual-result-issue-certificates',
      updatePermission: 'update-rpl-individual-result-issue-certificates',
      deletePermission: 'delete-rpl-individual-result-issue-certificates',
      createPermission: 'create-rpl-individual-result-issue-certificates',
      rplIndResultIssueCertificateButtonPermission: "rpl-ind-result-issue-certificate-button-permission",
      downloadCertificateButton: "rpl-ind-certificate-download-button-permission"
    },
    representativeAssignedAssessmentList: {
      menuPermission: 'menu-representative-assigned-assessment-list',
      readPermission: 'read-representative-assigned-assessment-list',
      updatePermission: 'update-representative-assigned-assessment-list',
      deletePermission: 'delete-representative-assigned-assessment-list',
      createPermission: 'create-representative-assigned-assessment-list',
    },
    rplIndividualRepresentativeAssignedAssessmentList: {
      menuPermission: 'menu-rpl-individual-representative-assigned-assessment-list',
      readPermission: 'read-rpl-individual-representative-assigned-assessment-list',
      updatePermission: 'update-rpl-individual-representative-assigned-assessment-list',
      deletePermission: 'delete-rpl-individual-representative-assigned-assessment-list',
      createPermission: 'create-rpl-individual-representative-assigned-assessment-list',
    },
    rplIndividualCreateCircular: {
      rplIndcreateCircular: "create-rpl-individual-circular",
      deleteCircularApplicationButton: "delete-applied-circular",
      editCircularApplicationButton: "edit-applied-circular"
    },
    rplIndividualBatch: {
      editRplIndividualBatchAssessment: "edit-rpl-individual-batch-assessment",
      viewRplIndividualBatchAssessment: "view-rpl-individual-batch-assessment",
      deleteRplIndividualBatchAssessment: "delete-rpl-individual-batch-assessment",
    },
    vewButtonPermissionForAssessor: 'view-button-permission-assessor',
    postExpiryCircularUpdatePermission: 'post-expiry-circular-update-button-permission',
    rplIndDownloadAttendanceSheetButtonPermission: 'rpl-ind-download-attendance-sheet-button-permission',
    rplIndDownloadRegistrationButtonPermission: 'rpl-ind-download-registration-button-permission',
    deleteCircularButton: 'delete-circular-button-permission',
    archiveUnarchiveCircularButton: 'archive-unarchive-circular-button-permission',
    publishUnpublishCircularButton: 'publish-unpublish-circular-button-permission',
    editCircularButtonPermission: 'edit-circular-button-permission',
    saveOrUpdateRplIndividualAssessment: "save-rpl-individual-assessment",
    applyforcircular: "applicant-apply-for-circular",
    createProfileApplicant: "create-profile-applicant",
    adminUpdateProfileApplicant: "admin-update-profile-applicant",

  },

  courseAccreditation: {
    menuPermission: 'menu-course-accreditation',
    courseAccreditation: {
      readPermission: 'read-course-accreditation',
      updatePermission: 'update-course-accreditation',
      deletePermission: 'delete-course-accreditation',
      createPermission: 'create-course-accreditation',
      rollbackPermission: 'rollBack-course-accreditation',
      menuApplyForCourseAccreditation: 'menu-apply-for-course-accreditation'
    },
    courseAccreditationList: {
      menuPermission: 'menu-course-accreditation-list',
      menuNsdaPermission: 'menu-course-accreditation-list-nsda',
      menuAppliedForCourseList: 'menu-applied-for-course-list',
      menuNotApprovedOccupationList: 'menu-not-approved-occupation-list',
      menuExpiredOccupationList: 'menu-expired-occupation-list',
      menuRenewalApplications: 'menu-renewal-applications',
      menuReapplyApplications: 'menu-reapply-applications',
      readPermission: 'read-course-accreditation-list',
      readPermissionAdmin: 'read-course-accreditation-list-admin',
      readPermissionInspector: 'read-course-accreditation-list-inspector',
      updatePermission: 'update-course-accreditation-list',
      deletePermission: 'delete-course-accreditation-list',
      createPermission: 'create-course-accreditation-list',
      editButtonPermission: 'button-edit-course-accreditation-list',
      deleteButtonPermission: 'button-delete-course-accreditation-list',
      downloadCertificateButtonPermission: 'button-download-course-accreditation-list',
    },
    scheduleInspection: {
      menuPermission: 'menu-schedule-inspection',
      readPermission: 'read-schedule-inspection',
      updatePermission: 'update-schedule-inspection',
      deletePermission: 'delete-schedule-inspection',
      createPermission: 'create-schedule-inspection ',
      genericPermission: 'schedule-inspection', //This permission used for all schedule inspection API
    },
    stpSacInspectionReport: {
      menuPermission: 'menu-stp-sac-inspection-report',
      readPermission: 'read-stp-sac-inspection-report',
      updatePermission: 'update-stp-sac-inspection-report',
      deletePermission: 'delete-stp-sac-inspection-report',
      createPermission: 'create-stp-sac-inspection-report',
    },
    scrutinyResult: {
      menuPermission: 'menu-scrutiny-result',
      readPermission: 'read-scrutiny-result',
      updatePermission: 'update-scrutiny-result',
      deletePermission: 'delete-scrutiny-result',
      createPermission: 'create-scrutiny-result',
      genericPermission: 'scrutiny-result-inspection', //This permission used for all Scrutiny  API
    },
    courseAccreditationPreview: {
      menuPermission: 'menu-course-accreditation-preview',
      readPermission: 'read-course-accreditation-preview',
      updatePermission: 'update-course-accreditation-preview',
      deletePermission: 'delete-course-accreditation-preview',
      createPermission: 'create-course-accreditation-preview',
    },
    completeInspection: {
      genericPermission: 'complete-inspection-report', //This permission used for all Complete inspection API
    },
    decision: {
      genericPermission: 'inspection-decision', //This permission used for all decision API
    },
    log: {
      stpActivityLogPermission: 'stp-activity-log-permission'
    }
  },

  stpRegistration: {
    menuPermission: 'menu-stp-registration',
    readPermission: 'read-stp-registration',
    stpApplicationView: {
      menuProfilePermission: 'menu-profile-view',
      menuFullViewPermission: 'menu-full-application-view',
      menuStpDownloadCertificate: 'menu-stp-download-certificate',
      menuEditPermission: 'menu-edit-application-view',
      readPermission: 'read-stp-application-view',
      viewApplicationListButtonPermission: 'button-view-application-list',
      updatePermission: 'update-stp-application-view',
      deletePermission: 'delete-stp-application-view',
      createPermission: 'create-stp-application-view',
      menuUpdateContactInformation: 'menu-update-contact-information',
    },
    stpApplication: {
      menuPermission: 'menu-stp-application',
      menuListPermission: 'menu-application-list',
      readPermission: 'read-stp-application',
      updatePermission: 'update-stp-application',
      deletePermission: 'delete-stp-application',
      createPermission: 'create-stp-application',
      editApplicationListButtonPermission: 'button-edit-application-list',
      reApplyApplicationListButtonPermission: 'button-reapply-application-list',
      renewApplicationListButtonPermission: 'button-renew-application-list',
      updateSTPNamePermission: 'update-stp-name',
      downloadCertificatePermission: 'download-stp-certificate',
      downloadCertificateButtonPermission: 'button-download-certificate-list',
      mailCertificatePermission: 'send-mail-stp-certificate',
      approveSTPPermission: 'approve-stp-application',
      rollbackSTPPermission: 'rollback-stp-application',
      tempApproveRejectPermission: 'temporary-approve-reject-stp-application',
      menuStpApplicationList: 'menu-stp-application-list',
      menuCorrectionRequestList: 'menu-correction-request-list',
      menuSetup: 'menu-setup',
      menuPreviousStpApplicationListPermission: 'menu-previous-stp-application-list',
    },
    stpRenewReapplyApplication:{
      menuStpRenewalApplicationListAdmin: 'menu-stp-renewal-application-list-admin',
      menuStpReapplyApplicationListAdmin: 'menu-stp-reapply-application-list-admin',
      // assigned NSDA officer: only the applications whose inspection is assigned to them
      menuAssignedStpRenewalApplicationList: 'menu-assigned-stp-renewal-application-list',
      menuAssignedStpReapplyApplicationList: 'menu-assigned-stp-reapply-application-list',
      inspectionSchedulingRenewReapplyButtonPermission: 'inspection-scheduling-renew-reapply-button',
      inspectionCompletionRenewReapplyButtonPermission: 'inspection-completion-renew-reapply-button',
      // backend: PUT stp-renew-reapply/submit-inspection-completion-report. "Any of" list (no spaces), the
      // same as the backend: the new permission or the existing complete-inspection-report.
      submitRenewReapplyInspectionCompletionReport: 'submit-renew-reapply-inspection-completion-report,complete-inspection-report',
      resultScrutinyRenewReapplyButtonPermission: 'result-scrutiny-renew-reapply-button',
      finalDecisionRenewReapplyButtonPermission: 'final-decision-renew-reapply-button',
      menuStpRenewReapplyArchiveListPermission: 'menu-stp-renew-reapply-archive-list-permission',
    },
    basicProfile: {
      readPermission: 'read-basic-profile',
      updatePermission: 'update-basic-profile',
      deletePermission: 'delete-basic-profile',
      createPermission: 'create-basic-profile',
      updateBasicProfileOrganizationDetails:
        'update-basic-profile-organization-details'
    },
    stpPayment: {
      readPermission: 'read-stp-payment',
      updatePermission: 'update-stp-payment',
      deletePermission: 'delete-stp-payment',
      createPermission: 'create-stp-payment',
    },
    dashBoard: {
      readPermission: 'read-dash-board',
      updatePermission: 'update-dash-board',
      deletePermission: 'delete-dash-board',
      createPermission: 'create-dash-board',
    },
    stpSuccess: {
      readPermission: 'read-stp-success',
      updatePermission: 'update-stp-success',
      deletePermission: 'delete-stp-success',
      createPermission: 'create-stp-success',
    },
    otpVerification: {
      readPermission: 'read-stp-otp-verification',
      updatePermission: 'update-stp-otp-verification',
      deletePermission: 'delete-stp-otp-verification',
      createPermission: 'create-stp-otp-verification',
    },
    qrCode: {
      readPermission: 'read-stp-qr-code',
      updatePermission: 'update-stp-qr-code',
      deletePermission: 'delete-stp-qr-code',
      createPermission: 'create-stp-qr-code',
    },
  },

  stpOperation: {
    menuPermission: 'menu-training-management',
    project: {
      menuPermission: 'menu-project',
      menuCeatePermission: 'menu-project-create',
      menuListPermission: 'menu-project-list',
      readPermission: 'read-project',
      updatePermission: 'update-project',
      deletePermission: 'delete-project',
      createPermission: 'create-project',
    },
    course: {
      menuPermission: 'menu-course',
      menuCeatePermission: 'menu-course-create',
      menuListPermission: 'menu-course-list',
      readPermission: 'read-course',
      updatePermission: 'update-course',
      deletePermission: 'delete-course',
      createPermission: 'create-course',
    },
    batch: {
      menuPermission: 'menu-batch',
      menuCreatePermission: 'menu-batch-create',
      menuListPermission: 'menu-batch-list',
      readPermission: 'read-batch',
      updatePermission: 'update-batch',
      deletePermission: 'delete-batch',
      createPermission: 'create-batch',
      readIndividualBatch: 'read-individual-batch'
    },
    trainer: {
      menuPermission: 'menu-trainer',
      menuCreatePermission: 'menu-trainer-create',
      menuListPermission: 'menu-trainer-list',
      readPermission: 'read-trainer',
      updatePermission: 'update-trainer',
      deletePermission: 'delete-trainer',
      createPermission: 'create-trainer',
      trainingBatchesByTrainer: 'training-batches-by-trainer'
    },
    trainee: {
      menuPermission: 'menu-trainee',
      menuCreatePermission: 'menu-trainee-create',
      menuListPermission: 'menu-trainee-list',
      readPermission: 'read-trainee',
      updatePermission: 'update-trainee',
      deletePermission: 'delete-trainee',
      createPermission: 'create-trainee',
      removeTrainee: 'remove-trainee',
      dropoutTrainee: 'dropout-trainee'
    },
    asseessmentApplication: {
      menuPermission: 'menu-assessment-application',
      menuAssessmentResultAdmin: 'menu-assessment-result-admin'
    },
    asseessmentStp: {
      menuAssessmentStp: 'menu-assessment-stp',
      menuAssessmentResultStp: 'menu-assessment-result-stp'
    },
    specialBatch: {
      menuSpecialBatch: 'menu-special-batch',
      menuSpecialBatchAdmin: 'menu-special-batch-admin',
      menuSpecialBatchApply: 'menu-special-batch-apply',
      menuSpecialBatchApplicationList: "menu-special-batch-application-list",
      menuSpecialBatchApplicationListAdmin: "menu-special-batch-application-list-admin",
      menuSpecialBatchAssignedAssessmentList: "menu-special-batch-assigned-assessment-list",
      resultScrutinyButtonSpecialBatch: "result-scrutiny-button-special-batch",
      issueCertificateButtonSpecialBatch: "issue-certificate-button-special-batch",
      specialBatchAttendanceAndResultSheetJasperReportDownloadPermission: "special-batch-attendance-and-result-sheet-download",
      menuSbCertificatesPending: 'menu-sb-certificates-pending',
    },
    approvedOccupations: {
      menuApprovedOccupationList: "menu-approved-occupations-list",
      readApprovedOccupations: "read-approved-occupations",
      readOtherAapprovedAssessmentCenter: "other-approved-assessment-center"
    },
    graduateTracking: {
      menuPermission: "menu-graduate-tracking",
      addGraduateTracking: "add-graduate-tracking",
      readGraduateTracking: "read-graduate-tracking"
    },
    newStpUser: {
      menuPermission: 'menu-new-stp-user',
      menuCreatePermission: 'menu-user-create',
      menuListPermission: 'menu-user-list',
      addNewStpUser: 'add-new-stp-user',
      newStpUserList: 'new-stp-user-list',
      updateNewStpUser: 'update-stp-user',
      readNewStpUser: 'read-new-stp-user',
      readStpUsersByStpMain: 'stp-users-by-stp-main-id'
    },
    executeTraining: {
      readExecuteTraining: "read-execute-training",
      addExecuteTraining: "add-execute-training",
      startExecuteTraining: "start-execute-training",
      completeExecuteTraining: "complete-execute-training"
    },
    regularAssessment: {
      menuPermission: 'menu-regular-assessment',
      menuListPermission: 'menu-regular-assessment-list',
      applyRegularAssessment: "apply-regular-assessment",
      updateRegularAssessment: "update-regular-assessment",
      submitRegularAssessment: "submit-reg-assessment",
      //not used yet in frontend
      readRegularAssessmentByBatch: "get-regular-assessment-by-batch",
      //not used yet in frontend
      readRegularAssessmentByApplication: "get-regular-assessment-by-application",
      correctionRequestForRegularAssessment: "correction-request-regular-assessment",
      acceptRegularAssessment: "accept-regular-assessment",
      readRegularAssessmentAdminList: "get-regular-assessment-admin-list",
      saveRegularAssessmentSchedule: "save-regular-assessment-schedule",
      submitRegularAssessmentSchedule: "submit-regular-assessment-schedule",
      resultScrutinyButtonRegular: "result-scrutiny-button-regular",
      issueCertificateButtonRegular: "issue-certificate-button-regular",

      menuRegularCertificatesPending: 'menu-regular-certificates-pending',
      menuRegularCertificatesIssued: 'menu-regular-certificates-issued',
      readRegularAssessmentPendingCertificate: "read-regular-assessment-pending-certificates",
      readRegularAssessmentIssuedCertificate: "read-regular-assessment-issued-certificates",
      reviewButtonRegular: "review-button-regular",
      regularAssessmentRollBack: "regular-assessment-roll-back",
      regularAssessmentViewEditTrainee: "regular-assessment-view-edit-trainee",
      viewTraineeById: "regular-batch-assessment-view-trainee-by-id",
      regularAttendanceAndResultSheetJasperReportDownloadPermission: "regular-batch-attendance-and-result-sheet-download",
    },
    rplAssessment: {
      menuPermission: 'menu-rpl-assessment',
      menuListPermission: 'menu-rpl-assessment-list',
      applyRplAssessment: "apply-rpl-assessment",
      updateRplAssessment: "update-rpl-assessment",
      submitRplAssessment: "submit-rpl-assessment",
      readRplAssessmentByApplication: "get-rpl-assessment-by-application",
      correctionRequestForRplAssessment: "correction-request-rpl-assessment",
      acceptRplAssessment: "accept-rpl-assessment",
      readRplAssessmentAdminList: "get-rpl-assessment-admin-list",
      saveRplAssessmentSchedule: "save-rpl-assessment-schedule",
      submitRplAssessmentSchedule: "submit-rpl-assessment-schedule",
      resultScrutinyButtonRpl: "result-scrutiny-button-rpl",
      issueCertificateButtonRpl: "issue-certificate-button-rpl",

      menuRplCertificatesPending: 'menu-rpl-certificates-pending',
      menuRplCertificatesIssue: 'menu-rpl-certificates-issued',
      readRplAssessmentPendingCertificate: "read-rpl-assessment-pending-certificates",
      readRplAssessmentIssuedCertificate: "read-rpl-assessment-issued-certificates",
      reviewButtonRpl: "review-button-rpl",
      rplAssessmentRollBack: "rpl-assessment-roll-back",
      rplBatchAssessmentViewEditCandidate: "rpl-batch-assessment-view-edit-candidate",
      viewCandidateById: "rpl-batch-assessment-view-candidate-by-id",
      rplAttendanceAndResultSheetJasperReportDownloadPermission: "rpl-batch-attendance-and-result-sheet-download",

      // readRplAssessmentAppListByCertificatesIssuedStatus: "get-rpl-assessment-app-list-by-certificates-issued-status",
      // readRplAssessmentAppListByCertificatesPendingStatus: "get-rpl-assessment-app-list-by-certificates-pending-status",
      // readRegularAssessmentAppListByCertificatesIssuedStatus: "get-regular-assessment-app-list-by-certificates-issued-status",
      // readRegularAssessmentAppListByCertificatesPendingStatus: "get-regular-assessment-app-list-by-certificates-pending-status"
    },
    commonForRplRegAssessment: {
      rplRegAssesApplicationStpList: "get-assessment-application-stp-list",
      //not used yet in frontend
      readAllAssessmentByStp: "read-all-assessment-by-stp",
      updatePaymentSlip: "update-payment-slip",
      menuAssessmentApplicationList: "menu-assessment-application-list",
    },
    stpListAdminView: {
      menuPermission: 'menu-stp-list-admin-view'
    },
    assessmentPayment: {
      regularAssessmentOfflinePayment: "save-reg-offline-payment",
      rplAssessmentOfflinePayment: "save-rpl-offline-payment"
    },
    rplCandidate: {
      menuRplCandidate: "menu-rpl-candidate",
      menuRegisterRplCandidate: "menu-register-rpl-candidate",
      menuCandidateList: "menu-candidate-list",
      menuAssessmentApply: "menu-assessment-apply",
      saveRplCandidate: "save-rpl-candidate",
      readCandidatesExcludingAssessmentId: "candidate-list-without-assessment-id",
      readRplCandidateByRegistrationNo: "read-rpl-candidate-by-registration-no",
      readAllCandidates: "read-all-candidates",
      updateCandidateForReassessment: "update-candidate-for-reassessment",
      readCandidateById: "read-candidate-by-id",
      deleteCandidate: "delete-candidate-by-id"
    },

    rplIndividualAssessment: {
      saveRplIndivScheduleAssessment: "save-rpl-individual-assessment",
      updateRplIndivScheduleAssessment: "update-rpl-individual-assessment",
      submitRplIndivScheduleAssessment: "submit-rpl-individual-assessment",
      deleteRplIndivScheduleAssessment: "delete-rpl-individual-assessment",
      getAllRplIndivScheduleAssessment: "getAll-rpl-individual-assessment",
      getRplIndivScheduleAssessment: "get-rpl-individual-assessment",
      getAllCandidateByAssessmentApplyId: "getAll-candidate-by-assessment-applyId",
      setProfileApplicantAssessmentIdToNull: "set-profile-applicant-assessmentId-toNull",
      getAllRplIndividualStatusType: "getAll-individual-status-type",
    },
    dashboard: {
      menuStpDashboard: "menu-stp-dashboard",
      menuAdminsDashboard: "menu-admins-dashboard",
      menuAssessorsDashboard: "menu-assessors-dashboard",
    },
    assessor: {
      getAssessorsByOccupationAndLevelRegRpl: "get-assessors-by-occupation-and-level-for-reg-rpl",
      getAssignedAssessmentList: "get-assigned-assessment-list",
      getUploadResultData: "get-upload-result-data",
      saveRegularRplResult: "save-regular-rpl-result",
      submitRegularRplResult: "submit-regular-rpl-result",
      approveResult: "approve-result",
      issueCertificates: "issue-certificates",
      assessorNeedCorrection: "assessor-need-correction",
      clarificationOrCorrection: "clarification-or-correction",
      menuAssessorApplicationListNsda: "menu-assessor-application-list-nsda",
      menuNsdaAssessorPool: "menu-nsda-assessor-pool",
      menuAssessorAccessView: "menu-assessor-access-view",
      menuEntryAssessorPool: "menu-entry-assessor-pool",
      menuAssessor: "menu-assessor",
      menuAssignedAssessmentList: "menu-assigned-assessment-list",
      menuRegularAssignedAssessmentList: "menu-regular-assigned-assessment-list",
      menuRplAssignedAssessmentList: "menu-rpl-assigned-assessment-list",
      menuAssessorFullProfileView: "menu-assessor-full-profile-view",
      withholdAssessorship: "withhold-assessorship"
    },
    FinancialApplication: {
      createapplication: "create-application",
    },
    rollback: {
      menuPermission: 'menu-rollback',
      rollbackStatus: {
        menuPermission: 'menu-rollback-status',
        rollBackApplicationStatus: 'get-rollback-application-status',
      },
    },
    log: {
      assessmentActivityLog: 'assessment-activity-log-permission',
      trainingManagementActivityLog: 'training-management-activity-log-permission'
    }
  },

  event: {
    menuPermission: 'menu-event',
    menuEventScheduleCreate: 'menu-event-schedule-create',
    menuEventListDashboard: 'menu-event-list-dashboard',
    eventScheduleCreate: 'event-schedule-create',
    eventScheduleReview: 'event-schedule-review',
    eventReportCreate: 'event-report-create',
    eventReportReview: 'event-report-review',
  },

  nap: {
    menuPermission: 'menu-nap',
    menuNapDashboard: 'menu-nap-dashboard',
    menuNapAgency: 'menu-nap-agency',
    menuNapCreateAgency: 'menu-nap-agency-create',
    menuNapAgencyUserList: 'menu-nap-agency-user-list',
    menuNapReview: 'menu-nap-review',
    menuNapTargetReview: 'menu-nap-target-review',
    menuTrainingTargetReview: 'menu-training-target-review',
    menuNapReportReview: 'menu-nap-report-review',
    menuTrainingReportReview: 'menu-training-report-review',
    menuNapTargetAdjReview: 'menu-nap-target-adj-review',
    menuTrainingTargetAdjReview: 'menu-training-target-adj-review',
  },

  policiesAndGuidelines: {
    menuPermission: 'menu-policies-and-guidelines',
    menuDocumentListNsda: 'menu-get-document-list-nsda',
    menuAddDocument: 'menu-add-document',
    menuArchivedList: 'menu-archived-list'
  },

  settings: {
    menuPermission: 'menu-settings',
    ministry: {
      menuPermission: 'menu-ministry',
      menuCreatePermission: 'menu-ministry-create',
      menuListPermission: 'menu-ministry-list',
    },

    agency: {
      menuPermission: 'menu-agency',
      menuCreatePermission: 'menu-agency-create',
      menuListPermission: 'menu-agency-list',
    },
    inspectionOfficer: {
      menuPermission: 'menu-inspection-officer-list',
    },
    addAssessor: {
      menuAddAssessor: 'menu-add-assessor',
    }
  },
  assessorPool: {
    assessorApplicationListNsda: {
      reviewApplicationPermission: 'review-application-button',
      giveDecisionPermission: 'give-decision-button',
      saveDecisionPermission: 'save-decision-button',
      submitDecisionPermission: 'submit-decision-button',
    },
    assessorFullProfile: {
      assessorFullProfileUpdateButtonPermission: 'assessor-full-profile-update-button-permission',
      readPermission: 'read-assessor-full-profile-correction-list',
      // Matches backend AuthorizationConstants.reviewAssessorFullProfileCorrection -
      // required for on-accept/on-reject-correction-request; readPermission alone
      // is not enough server-side.
      reviewPermission: 'review-assessor-full-profile-correction',
      menuPermission: 'menu-assessor-full-profile-correction-list'
    },
    assessorFullProfileAssessor: {
      readPermission: 'read-assessor-full-profile-correction-list-assessor',
      menuPermission: 'menu-assessor-full-profile-correction-list-assessor'
    },
    approvedAssessorsList: {
      viewDetailsButtonPermission: "view-details-button-permission",
      recordIssueButtonPermission: "record-issue-button-permission",
      manageButtonPermission: "manage-button-permission",
      complainBoxButtonPermission: "complain-box-button-permission",
    },
    resourcePerson: {
      menuResourcePersonList: 'menu-resource-person-list',
      resourcePersonExtendValidityPermission: 'resource-person-extend-validity-permission',
      resourcePersonEditPermission: 'resource-person-edit-permission',
    }
  },
  reports: {
    menuReportPermission: 'menu-report',
    menuPaymentCollection: 'menu-payment-collection',
    menuIssuedCertificates: 'menu-issued-certificates',
    menuStpInfo: 'menu-stp-info'
  },
  isc: {
    menuIscPermission: 'menu-isc',
    menuCreateIscPermission: 'menu-create-isc',
    menuRepresentativeIscPermission: 'menu-representative-isc',
    menuNsdaIscListPermission: 'menu-nsda-isc-list',
    menuRepresentativeIscListPermission: 'menu-representative-isc-list',
    nsdaIscEditPermission: 'nsda-isc-edit',
    iscLevel1ApprovalPermission: 'isc-level-1-approval',
    iscLevel2ApprovalPermission: 'isc-level-2-approval',
    iscLevel3ApprovalPermission: 'isc-level-3-approval',
    iscLevel4ApprovalPermission: 'isc-level-4-approval',
    iscPublishPermission: 'isc-publish',
    iscUnpublishPermission: 'isc-unpublish'
  },

  mra: {
    mraMenuPermission: 'menu-mra',
    mraAttachmentViewPermission: 'view-attachment-mra',
    mraAgreementTypeAddPermission: 'mra-agreement-type-add-permission',
    mraAgreementTypeEditPermission: 'mra-agreement-type-edit-permission',
    mraAgreementTypeDeletePermission: 'mra-agreement-type-delete-permission',
    mraCountryEditPermission: 'mra-country-edit-permission',
    mraountryDeletePermission: 'mra-country-delete-permission',
    mraEditPermission: 'mra-edit',
    mraDeletePermission: 'mra-delete',
    menuAddCountryPermission: 'menu-add-country',
    menuCreateMraPermission: 'menu-create-mra',
    menuMraListPermission: 'menu-mra-list'
  },

  programAndProjects: {
    programAndProjectsMenuPermission: 'menu-program-and-projects',
    projectMakerList: 'project-maker-list',
    menuProjectEnlistmentForm: 'menu-project-enlistment-form',
    menuProjectEnlistmentList: 'menu-project-enlistment-list',
    menuMonthlyReportList: 'menu-monthly-report-list',
    menuProjectCompletionReportList: 'menu-project-completion-report-list',
    menuProjectEnlistmentListAdmin: 'menu-project-enlistment-list-admin',
    menuMonthlyReportListAdmin: 'menu-monthly-report-list-admin',
    menuProjectCompletionReportAdminList: 'menu-project-completion-report-admin-list',
    menuProgramAndProjectActivityLog: 'menu-program-and-project-activity-log'
  },

  researchAndStudies: {
    menuResearchAndStudiesPermission: 'menu-research-and-studies',
    menuAddResearchAndStudiesPermission: 'menu-add-research-and-studies',
    menuListResearchAndStudiesAdminPermission: 'menu-list-research-and-studies-admin',
    menuListResearchAndStudiesPublicPermission: 'menu-list-research-and-studies-public',
    menuListExternalUsersPermission: 'menu-list-external-users',
    menuListIscUsersPermission: 'menu-list-isc-users',
    menuExternalUserRegFormFunctionPermission: 'menu-external-user-reg-form-function',
    addResearchTypeButton: 'add-research-type-button',
    addConductedByButton: 'add-conducted-by-button',
    addAuthorButton: 'add-author-button',
    addRoleButton: 'add-role-button',
    addSectorButton: 'add-sector-button',
    relatedResearchSearchButton: 'related-research-search-button',
    clickToApplyButton: 'click-to-apply-button',
    giveOpinionButton: 'give-opinion-button',
    addFormSaveButtonPermission: 'add-form-save-button',
    addFormSubmitButtonPermission: 'add-form-submit-button',
    adminListViewButtonPermission: 'admin-list-view-button',
    iscListViewButtonPermission: 'isc-list-view-button',
    externalUserListViewButtonPermission: 'external-user-list-view-button',
    demandSurveyEditButtonOnApprovalProcessPermission: 'demand-survey-edit-button-on-approval-process',
    levelOneRecommendationButtonPermission: 'level-one-recommendation-button-permission',
    levelTwoRecommendationButtonPermission: 'level-two-recommendation-button-permission',
    levelThreeRecommendationButtonPermission: 'level-three-recommendation-button-permission',
    historyLogViewButtonPermission: 'history-log-view-button',
    log: {
      rsActivityLogPermission: 'rs-activity-log-permission',
    },
  },
  financialApplication: {
    menuFinancing: "menu-financing",
    menuApplicationListStp: "menu-application-list-stp",
    menuApplicationListAdmin: "menu-application-list-admin",
    menuApplicationListNhrdf: "menu-application-list-nhrdf",
    menuFinancialCircularListAdmin: "menu-financial-circular-list-admin",
    menuCircularListStp: "menu-circular-list-stp",
    menuCreateCircular: "menu-create-circular",
    menuResolution: "menu-resolution",
    menuResolutionList: "menu-resolution-list",
    summarySheet: "summary-sheet",
    nsdaLevel1Approval: "nsda-level-1-approval",
    nsdaLevel2Approval: "nsda-level-2-approval",
    nhrdfLevel1Approval: "nhrdf-level-1-approval",
    nhrdfLevel2Approval: "nhrdf-level-2-approval",
    correctionApplicationResubmission: "correction-application-resubmission"
  },

  evolutionForm: {
    menuEvolutionForm: "menu-evolution-form",
    menuStpEvolutionForm: "menu-stp-evolution-form",
    menuTrainerEvolutionForm: "menu-trainer-evolution-form",
    menuTraineeEvolutionForm: "menu-trainee-evolution-form"
  },

  certificateCorrectionForm: {
    menuCertificateCorrectionApplication: "menu-certificate-correction-application",
    menuCertificateCorrectionRepresentativeList: "menu-certificate-correction-representative-list",
    menuCertificateCorrectionScrutinyList: "menu-certificate-correction-scrutiny-list",
    menuCertificateCorrectionMemberList: "menu-certificate-correction-member-list",
    menuCertificateCorrectionECList: "menu-certificate-correction-ec-list",
    menuCertificateCorrectionList: "menu-certificate-correction-list"
  },

  emailLog: {
    menuPermission: 'menu-email-log',
    readPermission: 'read-email-log',
  }
};
